(function () {
  'use strict';

  var STORAGE_KEY = 'tb_delivery_pincode';
  var ETD_ASSET_URL = (function () {
    var script = document.querySelector('script[src*="tb-estimated-delivery.js"]');
    if (!script || !script.src) return '/assets/tb-etd-pincodes.json';
    return script.src.replace('tb-estimated-delivery.js', 'tb-etd-pincodes.json');
  })();

  var etdDataPromise = null;
  var pincodeMap = null;
  var zoneMap = null;

  // Fallback ranges when a PIN is missing from ETD-pincode sheet data.
  // Timelines match the sheet zone legend (A–E): 2-3 / 3-4 / 4-5 / 5-7 / 7-9 days.
  var REGIONS = [
    { key: 'north', label: 'North India', estimate: '5-7 days', ranges: [[11, 19], [20, 28]] },
    { key: 'west', label: 'West India', estimate: '5-7 days', ranges: [[30, 34], [36, 39], [40, 44]] },
    { key: 'central', label: 'Central India', estimate: '5-7 days', ranges: [[45, 49]] },
    { key: 'south', label: 'South India', estimate: '5-7 days', ranges: [[50, 53], [54, 59], [60, 64], [65, 66], [67, 69]] },
    { key: 'east', label: 'East India', estimate: '5-7 days', ranges: [[70, 77], [78, 79], [80, 85]] }
  ];

  function loadEtdData() {
    if (etdDataPromise) return etdDataPromise;

    etdDataPromise = fetch(ETD_ASSET_URL)
      .then(function (response) {
        if (!response.ok) throw new Error('ETD data unavailable');
        return response.json();
      })
      .then(function (data) {
        zoneMap = data && data.zones ? data.zones : null;
        pincodeMap = data && data.pincodes ? data.pincodes : null;
        return data;
      })
      .catch(function () {
        pincodeMap = null;
        zoneMap = null;
        return null;
      });

    return etdDataPromise;
  }

  function getRegionByPincode(pincode) {
    var prefix = parseInt(pincode.slice(0, 2), 10);
    if (isNaN(prefix)) return null;

    for (var i = 0; i < REGIONS.length; i++) {
      var region = REGIONS[i];
      for (var j = 0; j < region.ranges.length; j++) {
        var range = region.ranges[j];
        if (prefix >= range[0] && prefix <= range[1]) {
          return region;
        }
      }
    }

    return null;
  }

  function resolveEstimate(value) {
    if (!value) return null;
    if (zoneMap && zoneMap[value]) return zoneMap[value];
    return value;
  }

  function getEstimateByPincode(pincode) {
    if (pincodeMap && pincodeMap[pincode]) {
      return resolveEstimate(pincodeMap[pincode]);
    }

    var region = getRegionByPincode(pincode);
    return region ? region.estimate : null;
  }

  function isValidPincode(pincode) {
    return /^[1-8][0-9]{5}$/.test(pincode);
  }

  function fetchLocation(pincode) {
    return fetch('https://api.postalpincode.in/pincode/' + pincode)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!Array.isArray(data) || data[0].Status !== 'Success' || !data[0].PostOffice || !data[0].PostOffice.length) {
          return null;
        }

        var office = data[0].PostOffice[0];
        return {
          district: office.District,
          state: office.State
        };
      })
      .catch(function () {
        return null;
      });
  }

  function setLoading(widget, isLoading) {
    widget.classList.toggle('is-loading', isLoading);

    var button = widget.querySelector('[data-tb-delivery-check]');
    var input = widget.querySelector('[data-tb-delivery-input]');

    if (button) {
      button.disabled = isLoading;
      button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (input) {
      input.readOnly = isLoading;
    }
  }

  function setResult(widget, type, html) {
    var result = widget.querySelector('[data-tb-delivery-result]');
    if (!result) return;

    result.hidden = false;
    result.className = 'tb-estimated-delivery__result tb-estimated-delivery__result--' + type;
    result.innerHTML = html;
  }

  function showLoader(widget, pin) {
    setLoading(widget, true);
    setResult(
      widget,
      'loading',
      '<span class="tb-estimated-delivery__loader" aria-hidden="true"></span>' +
        '<p>Checking delivery for <strong>' + pin + '</strong></p>'
    );
  }

  function checkDelivery(widget, pincode, options) {
    options = options || {};
    var input = widget.querySelector('[data-tb-delivery-input]');
    var pin = (pincode || '').replace(/\D/g, '').slice(0, 6);

    if (input) input.value = pin;

    if (!pin) {
      setLoading(widget, false);
      setResult(widget, 'error', '<p>Please enter your 6-digit PIN code.</p>');
      return;
    }

    if (!isValidPincode(pin)) {
      setLoading(widget, false);
      setResult(widget, 'error', '<p>Please enter a valid 6-digit Indian PIN code.</p>');
      return;
    }

    showLoader(widget, pin);

    Promise.all([loadEtdData(), fetchLocation(pin)]).then(function (results) {
      var estimate = getEstimateByPincode(pin);
      var location = results[1];

      if (!estimate) {
        setResult(
          widget,
          'error',
          '<p>We could not determine delivery for this PIN code. <a href="/pages/contact">Contact us</a> for help.</p>'
        );
        return;
      }

      var locationLine = '';
      if (location && (location.district || location.state)) {
        locationLine =
          '<p class="tb-estimated-delivery__location">' +
          [location.district, location.state].filter(Boolean).join(', ') +
          '</p>';
      }

      setResult(
        widget,
        'success',
        locationLine +
          '<p class="tb-estimated-delivery__estimate">Estimated delivery: <strong>' +
          estimate +
          '</strong></p>'
      );

      try {
        localStorage.setItem(STORAGE_KEY, pin);
      } catch (error) {
        /* ignore */
      }

      if (options.focusResult) {
        var result = widget.querySelector('[data-tb-delivery-result]');
        if (result) result.focus();
      }
    }).finally(function () {
      setLoading(widget, false);
    });
  }

  function initWidget(widget) {
    if (widget.getAttribute('data-tb-initialized') === 'true') return;
    widget.setAttribute('data-tb-initialized', 'true');

    var input = widget.querySelector('[data-tb-delivery-input]');
    var button = widget.querySelector('[data-tb-delivery-check]');
    if (!input || !button) return;

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();
      checkDelivery(widget, input.value);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkDelivery(widget, input.value);
      }
    });

    var savedPin = '';
    try {
      savedPin = localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      savedPin = '';
    }

    if (savedPin) {
      checkDelivery(widget, savedPin);
    }
  }

  function initAll() {
    document.querySelectorAll('.tb-estimated-delivery[data-tb-delivery]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
